<app-loyalty-program-nav></app-loyalty-program-nav>
<router-outlet></router-outlet>